import type { ThemeMode } from "../../../shared/types";
import { AccentPicker } from "./AccentPicker";

const THEME_OPTIONS: ReadonlyArray<{ value: ThemeMode; label: string }> = [
  { value: "light", label: "Clair" },
  { value: "dark", label: "Sombre" },
  { value: "system", label: "Auto" },
];

interface AppearanceSectionProps {
  readonly theme: ThemeMode;
  readonly onThemeChange: (theme: ThemeMode) => void;
  readonly showHolidays: boolean;
  readonly onToggleHolidays: () => void;
}

export function AppearanceSection({
  theme,
  onThemeChange,
  showHolidays,
  onToggleHolidays,
}: AppearanceSectionProps) {
  return (
    <div className="flex flex-col gap-5">
      {/* Theme selector */}
      <div>
        <label className="text-xs font-medium text-ink-muted mb-2 block">
          Thème
        </label>
        <div className="inline-flex rounded-lg bg-surface-alt p-1">
          {THEME_OPTIONS.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              onClick={() => onThemeChange(value)}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                theme === value
                  ? "bg-surface text-ink shadow-sm"
                  : "text-ink-muted hover:text-ink"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Accent color */}
      <div>
        <label className="text-xs font-medium text-ink-muted mb-2 block">
          Couleur d'accent
        </label>
        <AccentPicker />
      </div>

      {/* Holidays toggle */}
      <div className="flex items-center justify-between">
        <div>
          <span className="text-xs font-medium text-ink">Jours fériés</span>
          <p className="text-[11px] text-ink-muted">Afficher les jours fériés et dates notables</p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={showHolidays}
          onClick={onToggleHolidays}
          className={`relative w-9 h-5 rounded-full transition-colors ${showHolidays ? "bg-accent" : "bg-surface-alt border border-border"}`}
        >
          <span className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow-sm transition-transform ${showHolidays ? "translate-x-4" : ""}`} />
        </button>
      </div>
    </div>
  );
}
